'use client'

import React from 'react'

import { Footer, Header, Main, PageWrapper } from 'Components/Blocks'
import BuiltForProductTeamsSection from 'Components/Sections/BuiltForProductTeams'
import HomeHeroSection from 'Components/Sections/HomeHero'
import HowStartupCraftFitsTogetherSection from 'Components/Sections/HowStartupCraftFitsTogether'
import MeetStartupCraftSection from 'Components/Sections/MeetStartupCraft'
import RealProductsRealResultsSection from 'Components/Sections/RealProductsRealResults'
import { HomePageData } from 'Data/types'

type Props = {
  homePageData: HomePageData
}

function HomePage({ homePageData }: Props) {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <HomeHeroSection />
        <MeetStartupCraftSection />
        <RealProductsRealResultsSection />
        <BuiltForProductTeamsSection
          videoFullUrl={homePageData.homePage?.videoFullUrl}
        />
        <HowStartupCraftFitsTogetherSection />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export type { Props }
export default HomePage
